import { render, staticRenderFns } from "./cookieoptin.vue?vue&type=template&id=67f1092e&"
import script from "./cookieoptin.vue?vue&type=script&lang=ts&"
export * from "./cookieoptin.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\Thermotech\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('67f1092e')) {
      api.createRecord('67f1092e', component.options)
    } else {
      api.reload('67f1092e', component.options)
    }
    module.hot.accept("./cookieoptin.vue?vue&type=template&id=67f1092e&", function () {
      api.rerender('67f1092e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "Dev/js/components/cookieoptin/cookieoptin.vue"
export default component.exports